<div
  class="input-wrapper"
  [class.input-wrapper--form]="appearance() === 'form'"
  [class.input-wrapper--error]="hasError()"
  [class.input-wrapper--no-clear]="!clearable() || !inputText()"
  [class.input-wrapper--readonly]="readonly()"
>
  <input
    #input
    matInput
    type="text"
    [attr.aria-label]="placeholder()"
    class="ag-input"
    [value]="inputText()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [readonly]="readonly()"
    [matAutocomplete]="auto"
    [style.width.px]="widthPx()"
    [style.height.px]="heightPx()"
    [attr.aria-expanded]="isPanelOpen"
    [attr.aria-invalid]="hasError()"
    (input)="onInput($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur()"
    (keyup.enter)="onEnter()"
    data-testid="autocomplete-input"
  />

  @if (inputText() && clearable()) {
  <button
    type="button"
    class="icon-button clear-button"
    [attr.aria-label]="clearInputLabel"
    [disabled]="disabled()"
    (mousedown)="$event.preventDefault()"
    (click)="clearInput($event)"
    data-testid="autocomplete-clear-icon"
  >
    <mat-icon class="clear-icon">close</mat-icon>
  </button>
  }

  <button
    type="button"
    class="icon-button arrow-button"
    [attr.aria-label]="toggleOptionsLabel"
    [attr.aria-expanded]="isPanelOpen"
    [disabled]="disabled()"
    (mousedown)="$event.preventDefault()"
    (click)="togglePanel()"
    data-testid="autocomplete-dropdown-arrow"
  >
    <mat-icon class="arrow-icon">
      {{ isPanelOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>
  </button>

  <mat-autocomplete
    #auto="matAutocomplete"
    [panelWidth]="panelWidth"
    [displayWith]="displayOption"
    [hideSingleSelectionIndicator]="true"
    class="custom-autocomplete ag-custom-component-popup"
    (opened)="onPanelOpen()"
    (closed)="onPanelClose()"
    (optionSelected)="onOptionSelected($event)"
  >
    <div class="options-container">
      @if (loading()) {
      <mat-option
        class="loader-option"
        disabled
        data-testid="autocomplete-loader"
      >
        <div class="center">
          <mat-spinner diameter="20"></mat-spinner>
        </div>
      </mat-option>
      } @for ( option of filteredOptions(); track option.key; let i = $index ) {
      @let selected = isOptionSelected(option);
      <mat-option
        [value]="option"
        [class.selected-option]="selected"
        [attr.aria-selected]="selected"
        [attr.data-testid]="'autocomplete-option-' + i"
        (mousedown)="selectOptionByMouse(option, $event)"
      >
        {{ option.displayValue ?? option.value }}
      </mat-option>
      }
    </div>
  </mat-autocomplete>
</div>
